module.exports = __webpack_public_path__ + "static/media/spritesheet.a053dc90.svg";